import { Injectable } from "@angular/core";
import { Http, Headers, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';
import {Md5} from 'ts-md5/dist/md5';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Rx';
import { GlobalVariable } from '../global';
@Injectable()

export class LoginService{

   // BASE_URL = 'http://localhost:1234';
    private BASE_URL = GlobalVariable.BASE_URL; 
    TOKEN_KEY = 'token';
    NAME_KEY = 'name';
    ROLL_KEY = 'roll';
    DESIGNATION = 'designation';
    GRADE = 'grade';
    TH = 'tokenHeader';
    EC = 'employeeCode';
    

    constructor( private http : Http ,private router: Router){}
    login(loginData)
    {
        console.log(loginData);
        loginData.password = Md5.hashStr(loginData.password);
       return this.http.post( this.BASE_URL + '/login/doLogin', loginData).map(res => res.json());
    }
    authenticate(res) {
            localStorage.setItem(this.TOKEN_KEY,res.token);
            localStorage.setItem(this.NAME_KEY,res.employee_name);
            localStorage.setItem(this.ROLL_KEY,res.roll_id);
            localStorage.setItem(this.DESIGNATION,res.designation);
            localStorage.setItem(this.GRADE,res.grade);
            localStorage.setItem(this.EC,res.employee_code);
            //console.log(res.token + ' ' + res.employee_name + res.roll_id)
           
    }
    changePwd(pwdData)
    {
        
        pwdData.password = Md5.hashStr(pwdData.password);
        pwdData.repassword = Md5.hashStr(pwdData.repassword);
       return this.http.post( this.BASE_URL + '/login/change_password', pwdData,this.tokenHeader).map(res => res.json());
    }
    
    logout() {
        localStorage.removeItem(this.NAME_KEY);
        localStorage.removeItem(this.TOKEN_KEY);
        localStorage.removeItem(this.ROLL_KEY);
        localStorage.removeItem(this.DESIGNATION);
        localStorage.removeItem(this.GRADE);
        localStorage.removeItem(this.EC);

        this.router.navigate(['/']);
    }
    get name() {
        return localStorage.getItem(this.NAME_KEY);
    }
    get role()
    {
        return localStorage.getItem(this.ROLL_KEY);
    }
    get token()
    {
        return localStorage.getItem(this.TOKEN_KEY);
    }
    get designation()
    {
        return localStorage.getItem(this.DESIGNATION);
    }
     get grade()
    {
        return localStorage.getItem(this.GRADE);
    }
    get tokenHeader() {
        var header = new Headers({'Authorization': 'exp108 ' + localStorage.getItem(this.TOKEN_KEY) + ' '+localStorage.getItem(this.ROLL_KEY)});
        return new RequestOptions({ headers: header});
    }
    get employeeCode()
    {
        return localStorage.getItem(this.EC);
    }
    get isAuthenticated() {
        return !!localStorage.getItem(this.TOKEN_KEY);
    }

}


// WEBPACK FOOTER //
// ./src/app/services/login.service.ts